import { render, staticRenderFns } from "./FlightInfoNav.vue?vue&type=template&id=4940147a&scoped=true&"
import script from "./FlightInfoNav.vue?vue&type=script&lang=js&"
export * from "./FlightInfoNav.vue?vue&type=script&lang=js&"
import style0 from "./FlightInfoNav.vue?vue&type=style&index=0&id=4940147a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940147a",
  null
  
)

export default component.exports